import './IncompleteRASApplicationCard.scss';

import React, { Fragment } from 'react';

import BaseCard from 'components/shared/Card/BaseCard';
import Content from 'services/Content';
import { financialPlanningServiceLink } from 'services/Externals';

const IncompleteRASApplicationCard = () => {
  const footer = (
    <Fragment>
      <a
        rel="noreferrer"
        className="card-action-link"
        target="_blank"
        href={financialPlanningServiceLink}>
        Continue Planning
      </a>
    </Fragment>
  );

  return (
    <BaseCard
      title="Retirement Advisory Service"
      isLoading={false}
      footer={footer}
      className="standard ras-application-card">
      {Content.incompleteRASApplicationCopy}
    </BaseCard>
  );
};

export default IncompleteRASApplicationCard;
